import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "./reducers/bookingReducer";
import cityServices from "./services/cityServices";
import homeServices from "./services/homeServices";
import busServices from "./services/busSearchServices";
import bookingServices from "./services/bookingServices";

const store = configureStore({
  reducer: {
    bookingReducer,
    [homeServices.reducerPath]: homeServices.reducer,
    [cityServices.reducerPath]: cityServices.reducer,
    [busServices.reducerPath]: busServices.reducer,
    [bookingServices.reducerPath]: bookingServices.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(homeServices.middleware)
      .concat(busServices.middleware)
      .concat(bookingServices.middleware)
      .concat(cityServices.middleware),
});

export default store;
